import { random } from "./random";

const getInterval = (price, _digit) => {
  // if(price < 1){
  //   const decimalString = price.toString().split('.')[1];
  //   const zeroCount = decimalString ? decimalString.match(/^0*/)[0].length : 0;
  //   console.log(zeroCount, ">>>");
  // }
  // if(price < 1000){
  //   return [20, 10];
  // }
  // if(price > 10000){
  //   return [25, 15]
  // }
  const digits = 10 ** this.coinType.decimal;
  const max = 25 / digits;
  const min = 15 / digits;
  return [max, min];
}
/**
 * @param {number} price 当前价格
 * @param {number} digits 小数位数
 * @param {number} num 随机数数量
 * @returns 
 */
export const randCoinPrices = (price, digits, num) => {
  const max = 25;
  const min = 15;
  const digitsNum = 10 ** digits;
  let res = [];
  const maxNum = (Math.round(price * digitsNum) + max) /
    digitsNum;
  const minNum = (Math.round(price * digitsNum) - min) /
    digitsNum;
  res = random([minNum, price], { num: num / 2, digits })
  return [...res, ...random([price, maxNum], { num: num / 2, digits })]
}

/**
 * @param {number} price 当前价格
 * @param {number} digits 小数位数
 * @param {number} num 随机数数量
 * @returns 
 */
export const randCoinNums = (price, digits, num) => {
  const digitsNum = 10 ** (digits - 2);
  const min = 0.01 * digitsNum;
  const max = 10 * digitsNum;
  return random([min, max], { num, digits: 2 })
}

/**
 * @param {number} price 当前价格
 * @param {number} digits 小数位数
 * @param {number} num 随机数数量
 * @returns 
 */
export const randCoinPricesLess = (price, digits, num) => {
  const min = 15;
  const digitsNum = 10 ** digits;
  const minNum = (Math.round(price * digitsNum) - min) /
    digitsNum;
  return random([minNum, price], { num, digits });
}

/**
 * @param {number} price 当前价格
 * @param {number} digits 小数位数
 * @param {number} num 随机数数量
 * @returns 
 */
export const randCoinPricesMore = (price, digits, num) => {
  const max = 25;
  const digitsNum = 10 ** digits;
  const maxNum = (Math.round(price * digitsNum) + max) /
    digitsNum;
  return random([price, maxNum], { num: num, digits })
}